import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { useItemTransformAnimations } from '@Components/BigBrowse/bb2/meshes2/primitives/primitives.common';
import { a } from '@react-spring/three';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';

type Props = {
  item: GridCard<PlaneTypes>;
  children?: ReactNode;
};

export const TextPositioner = observer(function TextPositioner({
  item,
  children,
}: Props) {
  const { worldPosition: position } = item;

  const { x: xAnim, y: yAnim } = useItemTransformAnimations(
    item.key!,
    position
  );

  return (
    <a.group
      position-x={xAnim}
      position-y={yAnim}
      position-z={PLANE_DEFAULT_Z + 0.01}
    >
      {children}
    </a.group>
  );
});
